const services = [
  {
    icon: 'ri-award-line',
    title: 'ACHC Accreditation Preparation',
    desc: 'End-to-end guidance through every phase of the ACHC accreditation process, from initial assessment to final approval.',
  },
  {
    icon: 'ri-survey-line',
    title: 'Mock Surveys & Readiness Assessments',
    desc: 'Simulate the real ACHC survey experience to identify gaps and ensure your agency is fully prepared before the official visit.',
  },
  {
    icon: 'ri-file-text-line',
    title: 'Policy & Procedure Development',
    desc: 'Custom-built, ACHC-compliant policies and procedures tailored to your agency\'s operations and regulatory requirements.',
  },
  {
    icon: 'ri-search-eye-line',
    title: 'Compliance Audits',
    desc: 'Thorough audits of your current compliance posture to uncover vulnerabilities and implement corrective action plans.',
  },
  {
    icon: 'ri-group-line',
    title: 'Staff Training',
    desc: 'Targeted training programs that equip your team with the knowledge and skills to maintain ongoing ACHC compliance.',
  },
  {
    icon: 'ri-customer-service-2-line',
    title: 'Ongoing Compliance Support',
    desc: 'Continuous advisory support to help your agency sustain compliance, adapt to regulatory changes, and excel operationally.',
  },
];

export default function ServicesSection() {
  return (
    <section className="bg-[#0d0d0d] py-24">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-3 mb-4">
            <div className="w-8 h-px bg-[#d4af37]"></div>
            <span className="text-[#d4af37] text-xs uppercase tracking-[3px] font-semibold">Our Services</span>
            <div className="w-8 h-px bg-[#d4af37]"></div>
          </div>
          <h2 className="text-3xl md:text-5xl font-black text-white mb-4">
            Comprehensive ACHC Solutions
          </h2>
          <p className="text-[#888] text-lg max-w-xl mx-auto">
            Everything you need for successful accreditation — under one roof.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((svc) => (
            <div
              key={svc.title}
              className="group bg-[#161616] border border-[#d4af37]/10 rounded-xl p-8 hover:border-[#d4af37]/50 hover:-translate-y-2 transition-all duration-300 cursor-default"
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-[#d4af37]/10 mb-6 group-hover:bg-[#d4af37]/20 transition-colors duration-300">
                <i className={`${svc.icon} text-[#d4af37] text-2xl`}></i>
              </div>
              <h3 className="text-white font-bold text-lg mb-3 leading-snug">{svc.title}</h3>
              <p className="text-[#888] text-sm leading-relaxed">{svc.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
